import { ArrowLeftOutlined, ClockCircleOutlined, UserOutlined } from '@ant-design/icons';
import { Editor } from '@tinymce/tinymce-react';
import { Breadcrumb, Button, Col, Image, Row } from 'antd';
import { format, fromUnixTime } from 'date-fns';
import React, { useEffect, useRef, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { useLazyGetEventByIdQuery } from '../redux/EventApi';
import { ReactComponent as Download } from '../../../assets/images/download.svg';
import { useLazyGetFileByObjectIdAndTypeQuery } from '../../../redux/api/FileApi';
import { fileTypes } from '../../common/types/types';
import { exportFile } from '../../common/ts/CommonFunctions';

const EventDetail = () => {
    const divRef = useRef<HTMLDivElement>(null);
    const [trigger, response] = useLazyGetEventByIdQuery();
    const [fileTrigger, fileResponse] = useLazyGetFileByObjectIdAndTypeQuery();
    const params = useParams();
    const navigate = useNavigate();

    const [imgId, setImgId] = useState<number>(-1);

    useEffect(() => {
        scrollToStart();
    }, [])

    useEffect(() => {
        if (params.id && parseInt(params.id)) {
            trigger(parseInt(params.id));
            fileTrigger({
                objectId: parseInt(params.id),
                objectType: fileTypes.EVENT,
            })
        }
    }, [params, trigger, fileTrigger])

    useEffect(() => {
        if (fileResponse.data?.length) {
            let item = fileResponse.data.find(item => item.fileExtention === "png" || item.fileExtention === "jpg"
                || item.fileExtention === "jpeg");
            setImgId(item?.attachmentId || -1);
        }
    }, [fileResponse])

    const downloadFile = (id: number, name: string) => {
        exportFile(process.env.REACT_APP_API_URL + `/files/downloadFile/${id}`, name);
    }

    const scrollToStart = () => {
        if (divRef.current) {
            window.scrollTo(0, 0);
            window.scrollTo(0, divRef.current.offsetTop);
        }
    }

    return (
        <div
            ref={divRef}
            style={{
                // padding: '40px calc((100vw - 1440px) / 2) 40px',
                background: "#ececec",
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                flexDirection: 'column',
                width: '100%',
                paddingTop: 40,
                paddingBottom: 40,
            }}
        >
            <div className="responsive-padding-1440">
                <Breadcrumb separator="  " className="custom-breadcrumb">
                    <Breadcrumb.Item>
                        <Link to="/">
                            Trang chủ
                        </Link>
                    </Breadcrumb.Item>
                    <Breadcrumb.Item>
                        Tin tức - Sự kiện
                    </Breadcrumb.Item>
                </Breadcrumb>
            </div>

            <div className="responsive-padding-1440" style={{ paddingTop: 25 }}>
                <div className="font-size-28 font-bold">{response.data?.title || ""}</div>
                <div style={{ marginTop: 40, display: 'flex' }}>
                    <div>
                        <ClockCircleOutlined style={{ marginRight: 5, fontSize: 16 }} />
                        {response.data?.createdDate ? format(fromUnixTime(response.data?.createdDate / 1000), "HH:mm dd/MM/yyyy") : ""}
                    </div>
                    <div style={{ marginLeft: 35 }}>
                        <UserOutlined style={{ marginRight: 5, fontSize: 16 }} />Người đăng: <span>{response.data?.createdBy || ""}</span>
                    </div>
                </div>
                <div style={{ marginTop: 25, textAlign: 'justify' }} className="font-bold">
                    {response.data?.summary}
                </div>
                {imgId >= 0 ?
                    <div style={{ marginTop: 30, textAlign: 'center', maxHeight: 500 }}>
                        <Image
                            style={{ maxHeight: 500 }}
                            src={process.env.REACT_APP_API_URL + `/files/downloadFile/${imgId}`}
                            preview={false}
                        />
                    </div> :
                    <></>}
                <div style={{ marginTop: 20 }} className="editor">
                    <Editor
                        onLoadContent={scrollToStart}
                        tinymceScriptSrc="/tinymce/tinymce.min.js"
                        value={response.data?.content || ""}
                        init={{
                            menubar: false,
                            toolbar: false,
                            content_style: 'body { font-family:Times New Roman; font-size:13px; margin: 0 }',
                            contextmenu: false,
                            plugins: ['autoresize']
                        }}
                        disabled
                    />
                </div>
                {fileResponse.data?.length ?
                    <div style={{ marginTop: 10, letterSpacing: '0.1em', textAlign: 'center', fontSize: 16 }}>TÀI LIỆU ĐÍNH KÈM</div> : <></>}

                <div style={{ marginTop: 20 }}>
                    <Row align='middle' justify='center' style={{ marginBottom: 10 }}>
                        <Col
                            style={{ overflow: 'auto', maxHeight: 500 }}
                            span={10}
                        >
                            {fileResponse.data?.length ?
                                fileResponse.data.map(item => {
                                    if (item.fileExtention !== "png" && item.fileExtention !== "jpg" && item.fileExtention !== "jpeg") {
                                        return (
                                            <Row
                                                key={item.attachmentId}
                                                style={{
                                                    background: "#f9f9f9",
                                                    borderRadius: 30,
                                                    height: 50,
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center',
                                                    padding: '0px 30px',
                                                    marginBottom: 10,
                                                }}
                                                className="custom-card-hover cursor-pointer"
                                                onClick={() => downloadFile(item.attachmentId, item.fileName)}
                                            >
                                                <Col
                                                    span={18}
                                                    className="font-size-16 font-bold"
                                                    style={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
                                                >
                                                    {item.fileName}
                                                </Col>
                                                <Col
                                                    span={6}
                                                    style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
                                                    <Download />
                                                    <span style={{ marginLeft: 8, whiteSpace: 'nowrap' }} className="anchor-text">Tải xuống</span>
                                                </Col>
                                            </Row>
                                        )
                                    }

                                    return <></>;
                                })
                                : <></>}
                        </Col>
                    </Row>
                </div>

                {/* <div
                    style={{ marginTop: 55, textAlign: 'center', color: "#787885", fontSize: 12, cursor: 'pointer' }}
                    onClick={() => navigate("/event")}
                >
                    <ArrowLeftOutlined />
                    <span style={{ marginLeft: 6 }}>Quay lại danh sách Tin tức - Sự kiện</span>
                </div> */}
                <div style={{ display: "flex", justifyContent: "center" }}>
                    <Button onClick={() => navigate(-1)} className="button-light-yellow" style={{ height: 45, width: 200 }} block htmlType="submit">Quay lại</Button>
                </div>
            </div>


        </div>
    )
}

export default EventDetail;